import React from 'react';
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { DataContext } from './DataContextProvider.js';

export default function Menu({ user }) {
  const dataContext = React.useContext(DataContext);
  const isDocs = (dataContext.blog === 'docs');

  return (
    <Navbar bg="dark" variant="dark" className="sidebar">
        <Nav className="mr-auto flex-column">
          <Navbar.Brand as={Link} to="/">
            <img className="logo" src="/twilio.png" alt="" /> Blogalytics
          </Navbar.Brand>
          {user.subdomain &&
            <p>for <span className="subdomain">{user.subdomain}</span></p>
          }
          <div className="hr" />
          <p>
            <span className="small">Logged in as:</span><br />
            <img alt="" src={user.picture} className="picture" /> {user.name}
          </p>
          <div className="hr" />
          <LinkContainer to="/">
            <Nav.Link>Articles</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/products">
            <Nav.Link>Products</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/teams">
            <Nav.Link disabled={isDocs}>Teams</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/authors">
            <Nav.Link disabled={isDocs}>Authors</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/languages">
            <Nav.Link disabled={isDocs}>Computer Languages</Nav.Link>
          </LinkContainer>
         {/* <LinkContainer to="/human_languages">
            <Nav.Link disabled={isDocs}>Human Languages</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/countries">
            <Nav.Link>Countries</Nav.Link>
          </LinkContainer>
          */}
          <LinkContainer to="/article_years">
            <Nav.Link disabled={isDocs}>Publication Year</Nav.Link>
          </LinkContainer>
          {/*
          <LinkContainer to="/article_quarters">
            <Nav.Link disabled={isDocs}>Publication Quarter</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/article_months">
            <Nav.Link disabled={isDocs}>Publication Month</Nav.Link>
          </LinkContainer>
          */}
          <LinkContainer to="/lists">
            <Nav.Link>Custom Lists</Nav.Link>
          </LinkContainer>
          <div className="hr" />
         {/* <LinkContainer to="/dashboards/voices">
            <Nav.Link>DevContent Dashboard</Nav.Link>
          </LinkContainer>
         */}
          <LinkContainer to="/insights">
            <Nav.Link>Content Insights <em>(Beta)</em></Nav.Link>
          </LinkContainer>
          <div className="hr" />
          <LinkContainer to="/settings">
            <Nav.Link>Settings</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/help">
            <Nav.Link>Help</Nav.Link>
          </LinkContainer>
        </Nav>
    </Navbar>
  );
}
